import { render, staticRenderFns } from "./downloadPortalApp.vue?vue&type=template&id=08b44a6e&scoped=true&"
import script from "./downloadPortalApp.vue?vue&type=script&lang=js&"
export * from "./downloadPortalApp.vue?vue&type=script&lang=js&"
import style0 from "./downloadPortalApp.vue?vue&type=style&index=0&id=08b44a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b44a6e",
  null
  
)

export default component.exports